import { render, staticRenderFns } from "./LevDynamicBadge.vue?vue&type=template&id=befcacb8&scoped=true"
import script from "./LevDynamicBadge.vue?vue&type=script&lang=js"
export * from "./LevDynamicBadge.vue?vue&type=script&lang=js"
import style0 from "./LevDynamicBadge.vue?vue&type=style&index=0&id=befcacb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befcacb8",
  null
  
)

export default component.exports